@if (!erreurRecuperation()) {
  <div class="site-users">
    <app-liste-generique [proprietesAffichees]="proprietesAfficheesUtilisateurs" [listeObjets]="tabUtilisateurs()"></app-liste-generique>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}

<div class="footer">
  <div style="position: relative; width: 100%;">
    <button class="btn btn-primary" style="margin-right: 10px;" (click)="openAddModal()">
      <i class="fas fa-plus" style="padding-right: 5px;"></i>{{'GLOBAL.AJOUTER' | translate}}
    </button>
    <button class="btn btn-primary" style="position: absolute; right: 0;" (click)="openDeleteModal()">
      <i class="fas fa-trash" style="padding-right: 5px;"></i>{{'GLOBAL.SUPPRIMER' | translate}}
    </button>
  </div>
</div>


